import { applyLandingBrand } from "@/lib/siteHosts"

export const credibilityContent = applyLandingBrand({
  eyebrow: "FRACTOLABS RESEARCH LAB • INDUSTRY BENCHMARK #4026",
  h1: "2026 Roofing Industry Speed-to-Lead Index",
  subheadline:
    "A nationwide blind audit measuring real-world response times, customer leakage, and financial gaps across {count} active roofing contractors.",
  citationLead: "Suggested citation:",
  citationBody: "FractoLabs Research Lab (2026).",
  citationTitle:
    "National Speed-to-Lead Index & Revenue Leakage Audit across {count} Roofing Operations.",
  kpis: [
    { id: "slow", label: "Failed to respond within 24 hours" },
    { id: "average", label: "Industry average response delay" },
    { id: "fast", label: "Companies answering in under 60 seconds" },
    {
      id: "leakage",
      label: "Average estimated revenue leakage per contractor",
      value: "$52,400/mo",
    },
  ],
})
